//
// This must be in a separate file because it's imported by busSources.ts, which is also used
// in the browser, so it must only import zod types.
//
import { z } from 'zod/v4-mini';
import { matchingZodObject, matchingZodObjectLoose } from '../utilities/matchingZodObject.js';
// Minimum acceptable match object for a low maintenance burden.
const ZodPackageSettingsMatchObject = matchingZodObject({
    name: z.string(),
    version: z.optional(z.string()),
});
const ZodPackageSettingsMatch = z.union([z.string(), z.looseObject({ ...ZodPackageSettingsMatchObject.shape })]);
const ZodGeneratedPackageSettingsMatch = z.union([z.string(), z.required(ZodPackageSettingsMatchObject)]);
export const ZodGetLinkConfigOutput = matchingZodObjectLoose({
    packageSettings: z.optional(z.array(z.looseObject({ match: z.union([ZodPackageSettingsMatch, z.array(ZodPackageSettingsMatch)]) }))),
    generated: z.looseObject({ packageSettings: z.array(z.looseObject({ match: ZodGeneratedPackageSettingsMatch })) }),
});
//# sourceMappingURL=GetLinkConfigOutput.js.map